export type Point = { x: number; y: number };
// Rejection sampling keeps the circles apart without imposing rows or columns.
export function scatter(count: number, width: number, height: number, diameter: number): Point[] {
 const margin = diameter / 2 + 5, spacing = diameter + 10;
 for (let attempt = 0; attempt < 80; attempt++) {
  const points: Point[] = [];
  for (let trial = 0; trial < 2000 && points.length < count; trial++) {
   const point = {x: margin + Math.random() * Math.max(0, width - 2 * margin), y: margin + Math.random() * Math.max(0, height - 2 * margin)};
   if (points.every(p => Math.hypot(p.x - point.x, p.y - point.y) >= spacing)) points.push(point);
  }
  if (points.length === count) return points;
 }
 // A bounded fallback guarantees every character remains selectable on tight screens.
 const cols = Math.max(1, Math.floor((width - 10) / spacing)), rows = Math.ceil(count / cols);
 const points = Array.from({length: count}, (_, i) => ({x: (i % cols + .5) * width / cols, y: (Math.floor(i / cols) + .5) * height / rows}));
 for (let i = points.length - 1; i > 0; i--) {const j = Math.floor(Math.random() * (i + 1)); [points[i], points[j]] = [points[j], points[i]];}
 return points;
}
